import { STORE_CREATE_FAIL, STORE_CREATE_REQUEST, STORE_CREATE_RESET, STORE_CREATE_SUCCESS, STORE_DELETE_FAIL, STORE_DELETE_REQUEST, STORE_DELETE_RESET, STORE_DELETE_SUCCESS, STORE_GET_FAIL, STORE_GET_REQUEST, STORE_GET_SUCCESS, STORE_LIST_FAIL, STORE_LIST_REQUEST, STORE_LIST_SUCCESS, STORE_UPDATE_FAIL, STORE_UPDATE_REQUEST, STORE_UPDATE_RESET, STORE_UPDATE_SUCCESS } from "../constants/storeConstants";

export const storeCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case STORE_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case STORE_CREATE_SUCCESS:
      return {
        loading: false,
        store: action.payload,
        success: true,
      };
    case STORE_CREATE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case STORE_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const storeListReducer = (state = {}, action) => {
  switch (action.type) {
    case STORE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case STORE_LIST_SUCCESS:
      return {
        loading: false,
        stores: action.payload,
        success: true,
      };
    case STORE_LIST_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const storeGetReducer = (state = {}, action) => {
  switch (action.type) {
    case STORE_GET_REQUEST:
      return { loading: true, ...state };
    case STORE_GET_SUCCESS:
      return { loading: false, store: action.payload, success: true };
    case STORE_GET_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const storeUpdateReducer = (state = { brand: {} }, action) => {
  switch (action.type) {
    case STORE_UPDATE_REQUEST:
      return { loading: true };
    case STORE_UPDATE_SUCCESS:
      return { loading: false, success: true, store: action.payload };
    case STORE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case STORE_UPDATE_RESET:
      return { store: {} };
    default:
      return state;
  }
};

export const storeDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case STORE_DELETE_REQUEST:
      return { loading: true };
    case STORE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case STORE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
    case STORE_DELETE_RESET:
      return {};
  }
};
